/*
 * Project: bellcloud
 * File: packages/theme/tokens/typography.ts
 * Description: Typography tokens based on Bellcloud Design System
 */

export type FontSize = {
  xs: number;
  sm: number;
  md: number;
  lg: number;
  xl: number;
  /** Larger display / example layouts */
  xxl: number;
};

export type FontWeight = {
  regular: number;
  medium: number;
  semibold: number;
  /** alias of regular — legacy naming */
  normal: number;
  /** alias of semibold — legacy naming */
  bold: number;
};

export type LineHeight = {
  tight: number;
  normal: number;
};

export const fontSize: FontSize = {
  xs: 10,
  sm: 12,
  md: 14,
  lg: 15,
  xl: 20,
  xxl: 24,
};

export const fontWeight: FontWeight = {
  regular: 400,
  medium: 500,
  semibold: 600,
  normal: 400,
  bold: 600,
};

export const lineHeight: LineHeight = {
  tight: 1.2,
  normal: 1.3,
};
